module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "category-content"
  }, [_c('div', {
    staticClass: "main-width"
  }, [_vm._l((_vm.list), function(item) {
    return _c('div', {
      staticClass: "promotions-item"
    }, [_c('router-link', {
      attrs: {
        "tag": "div",
        "to": {
          name: 'PromotionsDetail',
          query: {
            id: item.activityId
          }
        }
      }
    }, [_c('div', {
      staticClass: "promotions-item-image"
    }, [_c('img', {
      attrs: {
        "src": _vm.imgAddress + item.picturePath
      },
      on: {
        "error": function($event) {
          return _vm.error(3)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "promotions-item-content"
    }, [_c('div', {
      staticClass: "promotions-item-title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "promotions-item-time"
    }, [_c('label', [_vm._v("活动开始时间：" + _vm._s(item.startTime))])]), _vm._v(" "), _c('div', {
      staticClass: "promotions-item-time"
    }, [_c('label', [_vm._v("活动结束时间：" + _vm._s(item.endTime))])]), _vm._v(" "), (item.remark == '') ? _c('div', {
      staticClass: "promotions-item-remark"
    }, [_vm._v("\n\t\t\t\t\t\t无\n\t\t\t\t\t")]) : _c('div', {
      staticClass: "promotions-item-remark"
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(item.remark) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "font-right promotions-update-time"
    }, [_vm._v("时间：" + _vm._s(item.releaseTime))])])])], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.pageNum,
      "total": _vm.total,
      "page-size": 10
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.pageNum = $event
      },
      "update:current-page": function($event) {
        _vm.pageNum = $event
      }
    }
  })], 1)], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71d54ade","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Promotions.vue
// module id = 539
// module chunks = 1